/**
 * API Service for fetching portfolio data from the backend
 */

const API_BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetch all portfolio data in a single request
 */
export const fetchPortfolio = async () => {
  const response = await fetch(`${API_BASE}/api/portfolio`);
  if (!response.ok) {
    throw new Error('Failed to fetch portfolio data');
  }
  return response.json();
};

/**
 * Fetch hero section data
 */
export const fetchHero = async () => {
  const response = await fetch(`${API_BASE}/api/hero`);
  if (!response.ok) {
    throw new Error('Failed to fetch hero data');
  }
  return response.json();
};

/**
 * Fetch about section data
 */
export const fetchAbout = async () => {
  const response = await fetch(`${API_BASE}/api/about`);
  if (!response.ok) {
    throw new Error('Failed to fetch about data');
  }
  return response.json();
};

/**
 * Fetch all ventures
 */
export const fetchVentures = async () => {
  const response = await fetch(`${API_BASE}/api/ventures`);
  if (!response.ok) {
    throw new Error('Failed to fetch ventures');
  }
  return response.json();
};

/**
 * Fetch all achievements
 */
export const fetchAchievements = async () => {
  const response = await fetch(`${API_BASE}/api/achievements`);
  if (!response.ok) {
    throw new Error('Failed to fetch achievements');
  }
  return response.json();
};

/**
 * Fetch all leadership roles
 */
export const fetchLeadership = async () => {
  const response = await fetch(`${API_BASE}/api/leadership`);
  if (!response.ok) {
    throw new Error('Failed to fetch leadership');
  }
  return response.json();
};

/**
 * Fetch all clients
 */
export const fetchClients = async () => {
  const response = await fetch(`${API_BASE}/api/clients`);
  if (!response.ok) {
    throw new Error('Failed to fetch clients');
  }
  return response.json();
};

/**
 * Fetch all media articles
 */
export const fetchMedia = async () => {
  const response = await fetch(`${API_BASE}/api/media`);
  if (!response.ok) {
    throw new Error('Failed to fetch media');
  }
  return response.json();
};

/**
 * Fetch featured media articles
 */
export const fetchFeaturedMedia = async () => {
  const response = await fetch(`${API_BASE}/api/media/featured`);
  if (!response.ok) {
    throw new Error('Failed to fetch featured media');
  }
  return response.json();
};

/**
 * Fetch all talks
 */
export const fetchTalks = async () => {
  const response = await fetch(`${API_BASE}/api/talks`);
  if (!response.ok) {
    throw new Error('Failed to fetch talks');
  }
  return response.json();
};

/**
 * Fetch featured talks
 */
export const fetchFeaturedTalks = async () => {
  const response = await fetch(`${API_BASE}/api/talks/featured`);
  if (!response.ok) {
    throw new Error('Failed to fetch featured talks');
  }
  return response.json();
};

/**
 * Fetch all education entries
 */
export const fetchEducation = async () => {
  const response = await fetch(`${API_BASE}/api/education`);
  if (!response.ok) {
    throw new Error('Failed to fetch education');
  }
  return response.json();
};

/**
 * Fetch contact information
 */
export const fetchContact = async () => {
  const response = await fetch(`${API_BASE}/api/contact`);
  if (!response.ok) {
    throw new Error('Failed to fetch contact');
  }
  return response.json();
};
